<div class="ddc-quiz-questions">
  <!-- =====================================================
       TAKING
  ====================================================== -->

  <div class="quiz-taking" *ngIf="isTaking()">
    <!-- Progress -->
    <div class="quiz-progress">
      <div class="progress-top">
        <span class="progress-count">
          {{ currentQuestionIndex + 1 }}
          <span>/ {{ totalQuestions }}</span>
        </span>

        <span class="progress-label"> {{ progress }}% </span>
      </div>

      <mat-progress-bar mode="determinate" [value]="progress"> </mat-progress-bar>
    </div>

    <!-- Question -->
    <section class="question-card" *ngIf="currentQuestion">
      <!-- Question metadata -->
      <div class="question-meta">
        <span class="question-number"> Question {{ currentQuestionIndex + 1 }} </span>

        <span class="question-level" [ngClass]="getLevelColor(currentQuestion.level)">
          {{ getLevelLabel(currentQuestion.level) }}
        </span>

        <span class="question-type">
          {{ currentQuestion.question_type }}
        </span>
      </div>

      <!-- Question text -->
      <div class="question-text">
        {{ currentQuestion.text }}
      </div>

      <!-- Answers -->
      <div class="answers-list">
        <button
          class="answer-option"
          *ngFor="let answer of currentQuestion.answers; let i = index"
          type="button"
          [class.correct]="isResultShown && isCorrectAnswer(currentQuestion.id, answer.id)"
          [class.selected]="isSelected(currentQuestion.id, answer.id)"
          [class.wrong]="isResultShown && isWrongAnswer(currentQuestion.id, answer.id)"
          (click)="onAnswerSelect(currentQuestion.id, answer.id)"
        >
          <span class="answer-letter">
            {{ ['A', 'B', 'C', 'D', 'E', 'F'][i] }}
          </span>

          <span class="answer-text">
            {{ answer.text }}
          </span>

          <mat-icon *ngIf="isSelected(currentQuestion.id, answer.id)"> check </mat-icon>

          <mat-icon *ngIf="isResultShown && isWrongAnswer(currentQuestion.id, answer.id)"> close </mat-icon>

          <mat-icon *ngIf="isResultShown && isCorrectAnswer(currentQuestion.id, answer.id)"> check </mat-icon>
        </button>
      </div>

      <!-- Navigation -->
      <div class="navigation-buttons">
        <button class="previous-button" mat-button [disabled]="isFirstQuestion" (click)="onPrevious()">
          <mat-icon>arrow_back</mat-icon>
          Previous
        </button>

        <button
          class="next-button"
          mat-flat-button
          [disabled]="!selectedAnswers.has(currentQuestion.id)"
          (click)="isLastQuestion ? onSubmit() : onNext()"
        >
          {{ isLastQuestion ? 'Finish quiz' : 'Next' }}

          <mat-icon>
            {{ isLastQuestion ? 'check' : 'arrow_forward' }}
          </mat-icon>
        </button>
      </div>
    </section>
  </div>

  <!-- =====================================================
       RESULT
  ====================================================== -->

  <div class="quiz-result" *ngIf="!isTaking() && result()">
    <section class="result-card">
      <div class="result-heading">
        <span class="eyebrow">QUIZ COMPLETE</span>
        <h2>Nice work.</h2>
      </div>

      <div class="result-main">
        <div class="score-circle" [ngClass]="getScoreColor()">
          <span class="score-percentage"> {{ getScorePercentage() }}% </span>

          <span class="score-label"> score </span>
        </div>

        <div class="score-details">
          <div class="detail-item">
            <span class="detail-value">
              {{ result()?.correct_count }}
            </span>
            <span class="detail-label"> Correct </span>
          </div>

          <div class="detail-item">
            <span class="detail-value">
              {{ result()?.total_questions }}
            </span>
            <span class="detail-label"> Questions </span>
          </div>

          <div class="detail-item" *ngIf="result()?.time_taken">
            <span class="detail-value">
              {{ formatTime(result()?.time_taken) }}
            </span>

            <span class="detail-label"> Time </span>
          </div>
        </div>
      </div>
    </section>

    <!-- Wrong answers -->
    <section class="wrong-answers" *ngIf="result()?.wrong_answered_questions?.length">
      <div class="section-heading">
        <h3>Review your answers</h3>
        <span>
          {{ result()?.wrong_answered_questions?.length }}
          incorrect
        </span>
      </div>

      <div class="wrong-item" *ngFor="let wrong of result()?.wrong_answered_questions">
        <div class="wrong-question">
          <span class="wrong-indicator"> ! </span>

          <span>
            {{ wrong.question.text }}
          </span>
        </div>

        <div class="answer-review">
          <div class="review-answer incorrect">
            <mat-icon>close</mat-icon>
            <div>
              <small>Your answer</small>
              <span>
                {{ wrong.selected_answer?.text }}
              </span>
            </div>
          </div>

          <div class="review-answer correct">
            <mat-icon>check</mat-icon>
            <div>
              <small>Correct answer</small>
              <span>
                {{ wrong.correct_answer?.text }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
